import "./polyfill";
// Initialize i18n FIRST, before any other imports that might use it
import { i18n } from "./i18nInit";
import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { history, persistor, store } from "app/store";
import { Provider } from "react-redux";
import AppRouter from "AppRouter";
import { PersistGate } from "redux-persist/integration/react";
import { ThemeProvider } from "@material-ui/styles";
import theme from "app/utils/theme";
import { CssBaseline } from "@material-ui/core";
import Analytics from "app/utils/analytics";
import generalSettings from "app/utils/settings";
import DevTools from "./DevTools";
import { buildURLSearchParams } from "./app/utils/urlHelper";
import ErrorFallback from "./components/Errors/ErrorFallback";
import { HistoryRouter as Router } from "redux-first-history/rr6";
import { initDatadogLogs, initDatadogRum } from "./app/utils/datadogInit";
import { ErrorBoundary } from "@datadog/browser-rum-react";
import { I18nProvider } from "@lingui/react";
import { idle } from "app/redux/slices/IdleSlice";
import { SocketCloseCodes } from "app/utils/socketHelper";

require("./global.d");

Analytics.setUp();

export const ACCEPTED_LOCALES = ["en_US", "en_CA", "fr_CA"];

if (generalSettings.dataDogSettings) {
  initDatadogRum(
    generalSettings.country,
    generalSettings.env,
    generalSettings.gitTag,
    generalSettings.dataDogSettings.applicationId,
    generalSettings.dataDogSettings.clientToken
  );
  initDatadogLogs(
    generalSettings.dataDogSettings.clientToken,
    generalSettings.country,
    generalSettings.env,
    generalSettings.gitTag
  );
}

const urlSearchParams = buildURLSearchParams(history.location.search);

// i18n is already initialized in i18nInit.ts
// Expose i18n instance globally for Cypress e2e tests
(window as any).i18n = i18n;

if (process.env.REACT_APP_ENABLE_DEBUGGING_FEATURES === "true") {
  (window as any).store = store; // Expose store for debugging
  (window as any).testActions = {
    triggerIdle: () => {
      store.dispatch(idle());
    },
    triggerGracefulDisconnect: () => {
      if (window.ctlSocket) {
        window.ctlSocket.close(
          SocketCloseCodes.CLOSE_APP_NORMAL,
          "Manual graceful disconnect"
        );
      }
    },
    triggerManualReconnect: () => {
      const { doConnect } = require("app/redux/actions/sockets");
      const user = store.getState().auth.user;
      store.dispatch(doConnect({ user, reconnecting: true }));
    },
    getState: () => store.getState(),
  };
}

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ErrorBoundary fallback={ErrorFallback}>
          <ThemeProvider theme={theme}>
            <CssBaseline />
            <I18nProvider i18n={i18n}>
              <Router history={history}>
                {generalSettings.enableDebuggingFeatures &&
                  urlSearchParams.has("debug") && <DevTools />}
                <AppRouter />
              </Router>
            </I18nProvider>
          </ThemeProvider>
        </ErrorBoundary>
      </PersistGate>
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
